import { authenticatedApi } from '../../../shared/api/apiClientUtils.ts';

export interface PhoneNumberInfo {
  id: string;
  phoneNumber: string;
  isPrimary?: boolean;
}

export interface DatabaseOrganisationInfo {
  id: string;
  name: string;
  roles: DatabaseRoleInfo[];
  isAvailableForSession: boolean;
}

export interface DatabaseRoleInfo {
  id: string;
  name: string;
  permissions: DatabasePermissionInfo[];
}

export interface DatabasePermissionInfo {
  id: string;
  name: string;
}

export interface DatabaseInfo {
  id: string;
  email: string;
  givenName: string;
  familyName: string;
  phoneNumbers: PhoneNumberInfo[];
  lastSelectedOrganisation: DatabaseOrganisationInfo | null;
  organisations: DatabaseOrganisationInfo[];
}

export interface MeResponse {
  databaseInfo: DatabaseInfo;
}

export const getMe = async (): Promise<MeResponse> => {
  const response = await authenticatedApi.get<MeResponse>('/api/v1/users/me');
  return response.data;
};
